module.exports = __webpack_public_path__ + "static/media/bagy3.4df20385.png";